/**
 * @file subscription.js
 *
 * Subscription API Service
 *
 * API calls to /api/v1/subscription.
 * Handles plan status, Stripe checkout, portal, and referrals.
 */
import api from "./api";

export const subscriptionService = {
  /** Get current plan, usage stats, and referral info. */
  getStatus: () => api.get("/subscription/status"),

  /** Create a Stripe Checkout session — returns { url } to redirect to. */
  createCheckout: (data = {}) => api.post("/subscription/checkout", data),

  /** Create a Stripe Customer Portal session — returns { url } to redirect to. */
  createPortal: () => api.post("/subscription/portal"),

  /** One-time activation of the 15-appointment Pro trial. */
  activateTrial: () => api.post("/subscription/activate-trial"),

  /** Get list of referrals made by the authenticated professional. */
  getReferrals: () => api.get("/subscription/referrals"),
};
